import React from 'react';
import {Formik, Form, Field} from 'formik';
import PropTypes from 'prop-types';
import {phoneNumber} from "../../validators";
import fetch from 'cross-fetch';
import config from '../../config';
import styled from 'styled-components';
import {Link} from "react-router-dom";
import DepositSection from "./DepositSection";
import Modal from "../../shared/Modal";
import DepositModal from "./DepositModal";


const Alert = styled.div`
  font-size: 16px;
  line-height: 25px;
  margin-top: 20px;
`;

const Message = styled.div`
  p {
    margin-bottom: 1.5em;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const CountryCode = styled.span``;

const PhoneField = styled(Field)`
`;

const PhoneComboField = styled.div`
  display: flex;
  justify-content: stretch;
  align-items: center;

  ${CountryCode} {
    margin-right: 12px;
    height: 50px;
    line-height: 2;
  }

  ${PhoneField} {
    flex-grow: 1;
  }
`;

const StyledForm = styled(Form)`
  ${Message} {
    margin-bottom: 10px;
  }
  ${PhoneComboField} {
    margin-bottom: 10px;
  }
`;

const status = {
  REQUIRE_DEPOSIT: "REQUIRE_DEPOSIT",
  CONFIRMED: "CONFIRMED",
  QUEUED: "QUEUED",
  UNKNOWN_PRO: "UNKNOWN_PRO",
  ERROR: "ERROR",
};


class ShiftConfirmForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
      phone: null,
    };
  }

  handleSubmit = (values, actions) => {
    actions.setSubmitting(true);
    const phone = '+65' + values.phone.replace(/\s/g, '');

    this.confirm(phone).then(() => {
      actions.setSubmitting(false);
    });
  };

  confirm = (phone) => {
    window.analytics.track("Shift - Clicked Book", {phone: phone});
    return fetch(config.apiRoot + `/shifts/${this.props.shift.id}/confirm/`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        phone: phone
      })
    }).then(response => {
      if (response.status === 200 || response.status === 201) {
        response.json().then(json => {
          if (json === status.REQUIRE_DEPOSIT) {
            this.setState({
              status: status.REQUIRE_DEPOSIT,
              phone: phone,
            });
            return;
          }

          this.setState({
            status: json.status
          });
        });
      } else if (response.status === 403) {
        this.setState({
          status: 'UNKNOWN_PRO'
        });
      }
    }, error => {
      console.error(error);
      this.setState({
        status: 'ERROR'
      });
    });
  };

  render() {
    console.log(this.state);
    return (
      <div>
        {(this.state.status === null || this.state.status === status.REQUIRE_DEPOSIT) && (
          <Formik
            initialValues={{
              phone: ''
            }}
            onSubmit={this.handleSubmit}
          >
            {({isSubmitting, isValid}) => (
              <StyledForm>
                <Message><p>Enter you phone number to book this shift.</p></Message>
                <PhoneComboField>
                  <CountryCode className="custom-select countryCode">+65</CountryCode>
                  <PhoneField
                    className="form-control phoneNumber"
                    name={'phone'}
                    type={'tel'}
                    placeholder={'Phone Number'}
                    validate={phoneNumber}
                  />
                </PhoneComboField>
                <button className="btn btn-primary btn-block btn-pointer"
                        disabled={!isValid || isSubmitting}
                        type={'submit'}>
                  Book
                </button>

              </StyledForm>
            )}
          </Formik>
        )}
        {this.state.status === status.REQUIRE_DEPOSIT && (
          <DepositModal open={true} phone={this.state.phone} onComplete={() => this.confirm(this.state.phone)}/>
        )}
        {this.state.status === status.CONFIRMED && (
          <Alert className="alert alert-success">
            <strong>Booked</strong>. You've been successfully scheduled for this shift. Please check your phone for the
            confirmation message.
          </Alert>
        )}
        {this.state.status === status.QUEUED && (
          <Alert className="alert alert-primary">
            <strong>In Queue</strong>. Someone responded before you did. We'll let you know if this shift opens up.
          </Alert>
        )}
        {this.state.status === status.UNKNOWN_PRO && (
          <Alert className="alert alert-primary">
            <strong>Hello New Friend</strong>. We don't recognize that phone number. Please <Link
            to={config.routes.prosSignUp}>sign up</Link> to book this shift.
          </Alert>
        )}
        {this.state.status === status.ERROR && (
          <Alert className="alert alert-danger">
            <strong>Oops</strong>. There was an error. Please try again.
          </Alert>
        )}
      </div>
    );
  }
}

ShiftConfirmForm.propTypes = {
  shift: PropTypes.object.isRequired,
};

export default ShiftConfirmForm;



// WEBPACK FOOTER //
// ./src/pages/shift-page/ShiftConfirmForm.js